import * as React from 'react';

import { Button, LoadingPanel, PageSplitDescription, PageSplitTitle } from '@gitbook/spine-react';
import { useHeadTitle } from '@gitbook/util-react-head';
import { useLoadingState } from '@gitbook/util-react-hooks';

import { MFAScreenModal } from '../../Components';
import { useHistory } from '../../navigation';
import { type FirebaseActionURLParams, useAuthOperations } from '../../state';
import { LoginScreenLayout } from './LoginScreenLayout';

/**
 * Step to verify the email address.
 */
export function StepApplyVerifyEmailLink(props: {
    action: FirebaseActionURLParams;
}): React.ReactElement {
    const { action } = props;
    const { mfa, applyActionCode, checkActionCode } = useAuthOperations();
    const [loading, wrapLoading] = useLoadingState(true);
    const history = useHistory();

    useHeadTitle('Verify email');

    React.useEffect(() => {
        wrapLoading(async () => {
            const info = await checkActionCode(action.oobCode);
            if (info) {
                await applyActionCode(action.oobCode);
            }
        });
    }, [action.oobCode]);

    if (mfa) {
        return <MFAScreenModal mfa={mfa} />;
    }

    if (loading) {
        return <LoadingPanel size="large" />;
    }

    const onGoToSignIn = () => {
        history.push({ pathname: history.location.pathname });
    };

    return (
        <LoginScreenLayout>
            <PageSplitTitle>Email verification</PageSplitTitle>
            <PageSplitDescription>
                Your email has been verified. You can safely continue to the application.
            </PageSplitDescription>
            <Button
                label="Continue"
                size="large"
                kind="primary"
                className="mb-4"
                onPress={onGoToSignIn}
            />
        </LoginScreenLayout>
    );
}
